import React from 'react'

export const Scroll = props => <div className='scroll'>{props.children}</div>
